import React, { useEffect } from 'react'
import { Container, Row } from 'react-bootstrap'
import AboutSection from '../../Utilitis/AboutSection/AboutSection'
import Section from '../../Utilitis/Section'
import SingalHeader from '../../Utilitis/SingalHeader'
import CouresesCategorie from '../HomePage/Home_Component/CouresesCategorie'
import Statistiques from '../HomePage/Home_Component/Statistiques'

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        < >
            <SingalHeader title="About AS" />
            <Section bg="#f3f7f9">
                <Container>
                    <Row>
                        <AboutSection />
                    </Row>
                </Container>
            </Section>
            <Statistiques />
            <CouresesCategorie />
        </>
    )
}
